import {getLanguage, t} from 'react-switch-lang';

const lang = getLanguage();

export const periods = [
  {value: 'DAY', label: (lang === 'eng' ? 'Day' : 'Dan')},
  {value: 'WEEK', label: (lang === 'eng' ? 'Week' : 'Nedjelja')},
  {value: 'MONTH', label: (lang === 'eng' ? 'Month' : 'Mjesec')},
  {value: 'QUARTER', label: (lang === 'eng' ? 'Quarter' : 'Četvrtina godine')},
  {value: 'HALFAYEAR', label: (lang === 'eng' ? 'Half-year' : 'Pola godine')},
  {value: 'YEAR', label: (lang === 'eng' ? 'Year' : 'Godina')},
];

export const escalationCalculationTypeOptions = [
  {value: 'COUNTER', label: t('common.counter')},
  {value: 'PERCENTAGE', label: t('common.percentage')},
  {value: 'SUM', label: t('common.sum')}
]